import React, { Component } from 'react';
import PAService from '../services/PASevice';
import UserPointTransactionService from '../services/UserPointTransactionService';
import MessageComponent from '../template/Message';
import ApiService from '../services/apiService';
import { Dialog } from 'primereact/dialog';
import SecondaryPackingService from '../services/SecondaryPackingService';

export default class DiProduct extends Component {
    constructor(props) {
        super(props);
        this.PAService = new PAService();
        this.ApiService = new ApiService();
        this.UserPointTransactionService = new UserPointTransactionService();
        this.SecondaryPackingService = new SecondaryPackingService();
        this.state = {
            visible: false,
            DIDDetails: []
        }
        this.hideFunc = this.hideFunc.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    // basic page operation
    componentDidMount() {
        debugger
        const urlParams = new URLSearchParams(window.location.search);

        //const parmUid = urlParams.get('uid');
        const DID = window.location.href
        setTimeout(() => {
            this.GetDIDDetails(DID);
        }, 1000);

    }
    handleClick(event) {
        debugger
        //this.GetDIDDetails(DID)
    }
    openDialog() {
        debugger
        this.setState({ visible: true });
        this.state.formHeading = "Product Details";
    }
    // get DID details
    GetDIDDetails(DID) {
        debugger
        this.SecondaryPackingService.GetDIDDetails(DID).then(data => {
            debugger
            const resdata = data.data.ResponseData;
            //if ResponseData is not null
            if (resdata !== null) {
                this.setState({
                    DIDDetails: resdata
                });
            }
            else {
                this.setState({
                    DIDDetails: []
                });
            }
        });
    }
    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Feedback'
        })
        // this.formReset();
    }

    // return HTML
    render() {
        const item = []
        for (const [index, value] of this.state.DIDDetails.entries()) {
            item.push(<li className="active" key={index}>{value.activity} {value.DiNo ? <span><i className="fa fa-clock-o"></i> {value.DiNo}</span> : null}
                {value.BatchNo ? <span><i className="fa fa-clock-o"></i> {value.BatchNo}</span> : null}
                {value.InvoiceNo ? <span><i className="fa fa-clock-o"></i> {value.InvoiceNo}</span> : null}
                {value.ProductName ? <span><i className="fa fa-clock-o"></i> {value.ProductName}</span> : null}
                {value.ProductCode ? <span><i className="fa fa-clock-o"></i> {value.ProductCode}</span> : null}
                {value.Qty ? <span><i className="fa fa-clock-o"></i> {value.Qty}</span> : null}
                {value.DiNo ? <span><i className="fa fa-clock-o"></i> {value.DiNo}</span> : null}
                {value.ProductName ? <span>Product Name:<i className=""></i> {value.ProductName}</span> : null} </li>)
        }
        const itemLength = (60 * item.length) + 'px';
        itemLength.toString();
        const mystyle = {
            height: itemLength
        }
        return (
            <div>
                <MessageComponent />
                <div className="container p-0">

                    {/* <div className="col-md-12 mt-5">
                        <ul className="timeline" style={mystyle}>
                            {item}
                        </ul>
                    </div> */}
                    <div>
                        SID Details
                    </div>
                    <div className="d-flex justify-content-around align-content-around flex-wrap" style={{ width: "95%", border: "2px solid #c3dce4", margin: "30px auto", borderRadius: "10px", padding: "15px" }}>
                        {this.state.DIDDetails && this.state.DIDDetails.map((item, index) => (
                            <div key={index} className="col-md-6 mb-3 d-flex justify-content-center p-2" >
                                <div className="card bg-card">
                                    <div className="card-header row mx-1">
                                        <div className="card-text">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {item.TerminalDispatchId ? (
                                                        <>
                                                            <div className="col-md-5 text-bold">TerminalDispatchId</div>
                                                            <div className="col-md-7 mb-3 text-muted">
                                                                {item.TerminalDispatchId}
                                                            </div>
                                                        </>
                                                    ) : null}
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Carton Id</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.TerminalDispatchId ? (
                                                                <a href={`di-details?${item.CartonId}`} onClick={this.handleClick()}>
                                                                    {item.CartonId}
                                                                </a>
                                                            ) : (
                                                                item.CartonId
                                                            )}
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Product Name</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.ProductName}
                                                        </div></div>

                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Product Code</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.ProductCode}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Chemical Name</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.ProductDscrptn}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Batch No.</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.BatchNo}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Plant</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.Plant}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Pack of Quantity</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.Qty}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Manufacture Date</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.ManufactureDate}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Expiry Date</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.ExpiryDate}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Created Date</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.CreatedDt}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Sale For</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.Remarks}
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Reciever Address</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.RecieverAddress}
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="col-md-12 border-bottom 1 p-2">
                                                        <div className="col-md-5 text-bold ">Dispatched Date</div>
                                                        <div className="col-md-7 mb-3 text-muted ">
                                                            {item.DispatchedDate}
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="my-1 d-flex justify-content-center pb-3">
                                        <button className="pa-btn1 py-2" onClick={this.openDialog} >All Products Details</button>
                                    </div> */}
                                </div>


                            </div>
                        ))}
                    </div>

                    {
                        // (this.state.verifyProduct.ResponseCode) != null ?
                        <Dialog className="popup-modal" header="All Product" visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                            <div className="m-5">
                                <form onSubmit={this.submitForm}>
                                    <div className="col-md-12 mb-3 d-flex justify-content-center p-2" >
                                        <div className="card bg-card">
                                            <div className="card-header row mx-1">
                                                <div className="w-25">
                                                    Product Code
                                                </div>
                                            </div>
                                            <div >
                                                <div className="card-text">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">Batch No.</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.ProductCd}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">Delivery To</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.BatchNo}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">DI qunatity</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.DispatchDate}
                                                                </div></div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">No. of Bags</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.DispatchDate}
                                                                </div></div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">Product Code</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.DispatchAddress}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">Description</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.DispatchAddress}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 border-bottom 1 p-2">
                                                                <div class="col-md-5 text-bold ">Invoice No.</div>
                                                                <div class="col-md-7 mb-3 text-muted ">
                                                                    {this.state.DispatchAddress}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Dialog>
                    }
                </div>
            </div >
        )
    }
}